module.exports = __webpack_public_path__ + "img/12.cdddc142.png";